export const CarrierColor = {
  AS: '#0074CA',
  HA: '#CE0C88',
  AMAZON: '#8C7EB8',
  QX: '#A3CD6A',
  OO: '#676767',
  DEFAULT: '#FFFFFF'
}